<div class="text-bg-highlight text-xlarge mb-4">{{ config.data.standardNamnObject.standardNamn }}</div>


<label for="">Ändra till</label>
<input class="form-control" type="text" #input [(ngModel)]="newName"  #nameModel="ngModel">
<p *ngIf="error" class="text-danger my-4">{{ errorMessage }}</p>

<p class="text-danger mt-2" *ngIf="nameModel.touched && validationError">
  {{ validationError }}
</p>

<p class="text-danger my-4" *ngIf="error">
  {{ errorMessage }}
</p>
<div class="d-flex my-4" *ngIf="!loading">
    <button type="button" class="btn btn-secondary flex-grow-1" [style.marginRight]="'20px'" (click)="close()">
      Avbryt
    </button>
    <button type="button" class="btn btn-primary flex-grow-1" (click)="save()" [disabled]="!newName">
      Spara
    </button>
  </div>
  <div class="d-flex flex-column align-items-center mt-4" *ngIf="loading">
    <p>Sparar standardnamn...</p>
    <p-progressSpinner></p-progressSpinner>
  </div>

